import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";
import { documentTemplatesApi } from "@/slices/documentTemplates/documentTemplatesApi";

export interface Folder {
  id: string;
  name: string;
  color: string | null;
  icon: string | null;
  description: string | null;
  ownerId: string;
  companyId: string | null;
  order: number;
  createdAt: string;
  updatedAt: string;
  _count: {
    documentTemplates: number;
  };
}

export const foldersApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "foldersApi",
    baseUrl: "/api/folders",
  }),
  reducerPath: "foldersApi",
  tagTypes: ["Folders"],
  endpoints: (builder) => ({
    getFolders: builder.query<{ data: Folder[] }, void>({
      query: () => "",
      providesTags: ["Folders"],
    }),
    createFolder: builder.mutation<
      { data: Folder },
      { name: string; color?: string }
    >({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Folders"],
    }),
    updateFolder: builder.mutation<
      { data: Folder },
      { id: string; data: { name?: string; color?: string; order?: number } }
    >({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Folders"],
    }),
    deleteFolder: builder.mutation<{ message: string }, { id: string }>({
      query: ({ id }) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Folders"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(documentTemplatesApi.util.invalidateTags(["Documents"]));
      },
    }),
    moveTemplateToFolder: builder.mutation<
      { data: any },
      { templateId: string; folderId: string | null }
    >({
      query: (body) => ({
        url: "/move-template",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Folders"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(documentTemplatesApi.util.invalidateTags(["Documents"]));
      },
    }),
  }),
});

export const {
  useGetFoldersQuery,
  useCreateFolderMutation,
  useUpdateFolderMutation,
  useDeleteFolderMutation,
  useMoveTemplateToFolderMutation,
} = foldersApi;
